import { InfoCard } from '@/components/info-card.js';
import { groupAvailabilitiesByDay } from '@/lib/coach-availability-utils.js';
import { formatPlainTime } from '@airreading/common';
import { CoachAvailability, DayOfWeek, teachingDays, DayOfWeekLabelMap } from '@airreading/common/data';

export interface TeachingAvailabilityCardProps {
  availabilities: CoachAvailability[];
  timeZone: string;
}

export function TeachingAvailabilityCard({ availabilities, timeZone }: TeachingAvailabilityCardProps) {
  const { availabilitiesByDay } = groupAvailabilitiesByDay(availabilities, timeZone);

  return (
    <InfoCard
      headerText={
        <div className="flex items-center gap-2">
          Teaching availability
          <span className="text-lg font-normal"> ({timeZone})</span>
        </div>
      }
    >
      <div className="grid grid-cols-7 divide-x divide-gray-200 border border-gray-200 p-2">
        {teachingDays.map((day: DayOfWeek) => {
          const dayAvailabilities = availabilitiesByDay.find((d) => d.day === day)?.availabilities ?? [];

          return (
            <div key={day}>
              <div className="font-semibold border-b border-gray-200 px-2 mb-1 pb-1">{DayOfWeekLabelMap[day].abbr}</div>
              {dayAvailabilities.length === 0 ? (
                <div className="text-muted">-</div>
              ) : (
                dayAvailabilities.map((availability, index) => {
                  const start = formatPlainTime(availability.startPlainTime, { hour12: true });
                  const end = formatPlainTime(availability.endPlainTime, { hour12: true });
                  const isLast = index === dayAvailabilities.length - 1;
                  return <div key={`${day}-${index}`} className="px-2">{`${start} - ${end}${isLast ? '' : ','}`}</div>;
                })
              )}
            </div>
          );
        })}
      </div>
    </InfoCard>
  );
}
